module.exports = __webpack_public_path__ + "static/media/maestro-icon.b8a3b073.svg";